import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function LandingFooter() {
  return (
    <footer className="bg-foreground text-white/70">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <AppLogo size={32} />
              <span className="font-700 text-white text-lg">Bozaat</span>
            </div>
            <p className="text-sm leading-relaxed text-white/50 mb-4">
              Eco Commerce. Quick Commerce. Your Way.
            </p>
            <p className="text-xs text-white/40">
              India&apos;s first eco-commerce and quick commerce platform for
              sustainable sellers.
            </p>
          </div>

          {/* Sellers */}
          <div>
            <h4 className="text-white font-600 text-sm mb-4">Sellers</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Become a Seller', href: '/seller-sign-up' },
                { label: 'Seller Login', href: '/seller-login' },
                { label: 'Seller Guidelines', href: '#' },
                { label: 'Seller Support', href: '#' },
              ]?.map((link) => (
                <li key={`footer-seller-${link?.label}`}>
                  <Link
                    href={link?.href}
                    className="text-sm text-white/50 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customers */}
          <div>
            <h4 className="text-white font-600 text-sm mb-4">Customers</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Create Account', href: '/customer-sign-up' },
                { label: 'Customer Login', href: '/customer-login' },
                { label: 'My Orders', href: '/customer-dashboard/orders' },
                { label: 'Support', href: '/customer-dashboard/support' },
              ]?.map((link) => (
                <li key={`footer-customer-${link?.label}`}>
                  <Link
                    href={link?.href}
                    className="text-sm text-white/50 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            © 2026 Bozaat. All rights reserved. Owned &amp; operated by Shungnu Private Limited.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-white/40">
              Made with 💚 for eco-conscious India
            </p>
            <span className="text-white/20 text-xs">|</span>
            <Link
              href="/about"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              About Us
            </Link>
            <Link
              href="/careers"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Careers
            </Link>
            <Link
              href="/press"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Press
            </Link>
            <Link
              href="/success-stories"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Success Stories
            </Link>
            <Link
              href="/privacy-policy"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms-of-service"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              href="/return-policy"
              className="text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Return &amp; Cancellation Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}